export const apps = [
  {
    id: 'learn-kannada-akshara',
    name: 'Learn Kannada Akshara',
    slug: 'learn-kannada-akshara',
    tagline: 'Kannada Alphabet for Kids',
    description: 'Help kids master all 49 Kannada letters with colorful flashcards, native audio pronunciation, and guided finger-tracing.',
    fullDescription: 'Kannada Akshara (ಕನ್ನಡ ಅಕ್ಷರ) makes learning the Kannada alphabet fun and interactive for children. All 49 letters — 15 vowels and 34 consonants — with tap-to-hear audio, stroke-by-stroke tracing practice, and daily streaks that keep kids coming back.',
    packageName: 'com.kabett.kannadakidslearning',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.kabett.kannadakidslearning',
    landingPageUrl: '/learn-kannada-alphabet/',
    category: 'Education',
    keywords: ['kannada alphabet for kids', 'learn kannada akshara', 'kannada letters tracing', 'kannada varnamale app', 'kannada alphabet app'],
    bgColor: 'bg-rose-50',
    accentColor: '#F2547D',
    icon: '/images/apps/learn-kannada-akshara.webp',
    features: [
      'All 49 Kannada letters with flashcards',
      'Native audio pronunciation',
      'Guided finger-tracing practice',
      'Daily streaks and rewards'
    ],
  },
  {
    id: 'kannada-janapada',
    name: 'Kannada Janapada',
    slug: 'kannada-janapada',
    tagline: 'Folk Songs & Videos',
    description: 'Experience the rich heritage of Karnataka with authentic Kannada folk songs, janapada videos, and traditional music.',
    fullDescription: 'Dive into the vibrant world of Kannada folk music with our curated collection of janapada songs and videos. Perfect for Kannada language lovers and culture enthusiasts who want to stay connected to Karnataka\'s rich musical heritage.',
    packageName: 'com.desiapp.kannadajanapada',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.desiapp.kannadajanapada',
    category: 'Entertainment',
    keywords: ['kannada janapada', 'kannada folk songs', 'janapada songs', 'kannada music app', 'karnataka folk music', 'janapada geethe'],
    bgColor: 'bg-orange-50',
    accentColor: '#C2722A',
    icon: '/images/apps/kannada-janapada.webp',
    features: [
      'Curated collection of authentic janapada songs',
      'Folk videos from Karnataka',
      'Easy-to-use interface',
      'Regular content updates'
    ],
  },
  {
    id: 'hindu-gods-quiz',
    name: 'Hindu Gods Quiz',
    slug: 'hindu-gods-quiz',
    tagline: 'Educational Quiz Game',
    description: 'Test your knowledge of Hindu mythology with engaging quizzes about Hindu Gods and Goddesses. Perfect for kids and adults.',
    fullDescription: 'Learn about Hindu mythology through fun and engaging quizzes. Discover fascinating facts about various Hindu Gods and Goddesses while testing your knowledge. Great educational app for the whole family.',
    packageName: 'com.kabett.kids.hindugodquiz',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.kabett.kids.hindugodquiz',
    category: 'Education',
    keywords: ['hindu gods quiz', 'hindu mythology quiz', 'kids quiz app', 'indian gods quiz', 'religious quiz', 'hindu gods game'],
    bgColor: 'bg-orange-50',
    accentColor: '#E89530',
    icon: '/images/apps/hindu-gods-quiz.webp',
    features: [
      'Educational quizzes about Hindu Gods',
      'Kid-friendly interface',
      'Learn while playing',
      'Beautiful illustrations'
    ],
  },
  {
    id: 'breath-break-pranayama',
    name: 'Breath Break Pranayama',
    slug: 'breath-break-pranayama',
    tagline: 'Breathing & Meditation',
    description: 'Practice pranayama breathing exercises and meditation for stress relief and mindfulness. Available on Android and Chrome.',
    fullDescription: 'Take a mindful break with guided pranayama breathing exercises. Whether you\'re at your desk or on the go, our app helps you find moments of calm through ancient breathing techniques. Available as both an Android app and Chrome extension.',
    packageName: 'net.breathbreak.pranayama',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=net.breathbreak.pranayama',
    landingPageUrl: '/anuloma-viloma/',
    chromeExtensionUrl: 'https://chromewebstore.google.com/detail/epjichmldhceknjpoihgjkgccmllpbeg',
    hasChromeExtension: true,
    category: 'Health & Fitness',
    keywords: ['pranayama app', 'breathing exercises', 'meditation app', 'stress relief', 'mindfulness', 'breath break'],
    bgColor: 'bg-green-50',
    accentColor: '#7CB342',
    icon: '/images/apps/breath-break-pranayama.webp',
    features: [
      'Guided pranayama exercises',
      'Multiple breathing techniques',
      'Stress relief and relaxation',
      'Available on Android & Chrome'
    ],
  },
  {
    id: 'hanuman-chalisa-hindi',
    name: 'Hanuman Chalisa Hindi',
    slug: 'hanuman-chalisa-hindi',
    tagline: 'Devotional App',
    description: 'Read and listen to Hanuman Chalisa in Hindi with audio, lyrics, and meaning. Perfect for daily prayers.',
    fullDescription: 'Experience the divine power of Hanuman Chalisa in Hindi. This devotional app features the complete Hanuman Chalisa with clear Hindi lyrics, audio recitation, and detailed meanings. Ideal for daily spiritual practice.',
    packageName: 'com.karlaapps.hanumanchalisahindi',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.karlaapps.hanumanchalisahindi',
    category: 'Books & Reference',
    keywords: ['hanuman chalisa hindi', 'hanuman chalisa app', 'hanuman chalisa audio', 'hindi devotional app', 'hanuman chalisa lyrics'],
    bgColor: 'bg-orange-50',
    accentColor: '#E67E22',
    icon: '/images/apps/hanuman-chalisa-hindi.webp',
    features: [
      'Complete Hanuman Chalisa in Hindi',
      'Audio recitation',
      'Lyrics with meaning',
      'Offline access'
    ],
  },
  {
    id: 'hanuman-chalisa-kannada',
    name: 'Hanuman Chalisa Kannada',
    slug: 'hanuman-chalisa-kannada',
    tagline: 'Devotional App',
    description: 'Read and listen to Hanuman Chalisa in Kannada with audio, lyrics, and meaning. For Karnataka devotees.',
    fullDescription: 'Experience the divine power of Hanuman Chalisa in Kannada. This devotional app features the complete Hanuman Chalisa with clear Kannada lyrics, audio recitation, and detailed meanings. Perfect for Kannada-speaking devotees.',
    packageName: 'com.karlaapps.hanumanchalisa',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.karlaapps.hanumanchalisa',
    category: 'Books & Reference',
    keywords: ['hanuman chalisa kannada', 'kannada hanuman chalisa', 'hanuman chalisa app kannada', 'kannada devotional app'],
    bgColor: 'bg-orange-50',
    accentColor: '#E67E22',
    icon: '/images/apps/hanuman-chalisa-kannada.webp',
    features: [
      'Complete Hanuman Chalisa in Kannada',
      'Audio recitation',
      'Lyrics with meaning',
      'Offline access'
    ],
  },
];

export const developerPageUrl = 'https://play.google.com/store/apps/dev?id=8297463101500330997';
